import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription, firstValueFrom } from 'rxjs';
import { DataNamesDTO } from 'src/app/features/locations-map/models/DataNamesDTO';
import { LocationDTO } from 'src/app/features/locations-map/models/LocationDTO';
import { LocationsService } from 'src/app/features/locations-map/services/Locations.service';
import { RouteSheetUtilService } from 'src/app/features/locations-map/services/RouteSheetUtil.service';
import { IGeoPosDataLocation } from 'src/app/features/routeMap/models/IDataLocation';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { GeneralLocationsDetailsPopUpComponent } from '../general-location-detail-popup/general-location-details-popup.component';
import { RouteSheetTab } from 'src/app/features/locations-map/models/RouteSheetTab';
import { EnumLocationCategories } from 'src/app/features/shared/helpers/enums/EnumLocationCategories';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LocationsLocationDetailPopupComponent } from '../locations-location-detail-popup/locations-location-detail-popup.component';

@Component({
  selector: "app-service-location-detail-popup",
  templateUrl: "./service-location-detail-popup.component.html",
  styleUrls: ["./service-location-detail-popup.component.css"],
})
export class ServiceLocationDetailPopupComponent {
  selectedTabIndex: number = 0;
  locationDTO: LocationDTO = {} as LocationDTO;
  locationCategoryShortName: string = "";
  routeSheets: RouteSheetTab[] = [];
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];
  isLoadingImages: boolean = true;
  parentIdentifier = "";
  parentCordX = "";
  parentCordY = "";
  FlyToOnOpen = false;
  FlyToParentOnClose = false;
  newDialogRef: MatDialogRef<LocationsLocationDetailPopupComponent>;

  detallesActivo: string[] = [];
  detallesGPS: string[] = [];

  isLoading: boolean = true;
  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  location_details_subscription: Subscription;
  location_getChildrenSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<ServiceLocationDetailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private routeSheetUtilService: RouteSheetUtilService,
    private mapHelperService: MapHelperService,
    private locationService: LocationsService,
    private notifyService: SwalNotificationService,
    private citronellaActionsService: CitronellaActionsService,
    private notificationsToastService: NotificationsToastService,
    private dialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    console.log("data", data);


    this.parentIdentifier = data.identifierParent != null ? data.identifierParent : "";
    this.locationDTO.identifier = data.identifier != null ? data.identifier : "";
    this.parentCordX = data.parentCoordX;
    this.parentCordY = data.parentCoordY;
    this.FlyToOnOpen = data.FlyToOnOpen != null ? data.FlyToOnOpen : false;
    this.FlyToParentOnClose = data.FlyToParentOnClose != null ? data.FlyToParentOnClose : false;

    this.GetLocation();
  }

  ngOnInit(): void {
    if (
      !!this.data.routeSheetLocation &&
      this.data.routeSheetLocation.noOrder == 1
    ) {
      // this.routeSheetUtilService.setRouteFromFirstLocationToParent(this.data.routeSheetLocation);
    }
  }

  ngOnDestroy(): void {
    if (this.location_details_subscription)
      this.location_details_subscription.unsubscribe();
    if (this.location_getChildrenSubscription)
      this.location_getChildrenSubscription.unsubscribe();

    this.routeSheetUtilService.clearRouteToPointLayer();
    if (!!this.parentCordX && !!this.parentCordY && this.FlyToParentOnClose) {
      this.mapHelperService.FlyToCamera(
        this.parentCordY,
        this.parentCordX,
        "15"
      );
    }

    if (this.newDialogRef) 
      this.newDialogRef.close();
  }

  GetLocation() {
    this.isLoading = true;
    this.location_details_subscription = this.locationService
      .getByIdentifier(this.locationDTO.identifier)
      .subscribe(
        async (data: EstatusJSON) => {
          if (data.isSuccess == true && data.result != null) {
            var properties = data.result;
            console.log("related Data", properties);
            await this.setDetailsData(properties);
            // this.getChildrenLocations();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.notifyService.message(
              "Se están cargando los detalles. Inténtelo de nuevo más tarde."
            );
            if (this.location_details_subscription)
              this.location_details_subscription.unsubscribe();
            this.dialogRef.close();
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  getChildrenLocations() {
    var categoriesList = JSON.parse(
      localStorage.getItem("listaCategorias")
    ).filter((item) => item.name.includes(EnumLocationCategories.Location));
    this.routeSheets = [];
    categoriesList.forEach((element) => {
      this.routeSheets.push({
        total: "-",
        routeSheetName: element.shortName,
        routeSheetIdLocationCategory: element.id,
      });
    });
  }

  loadTotal(total: string, routeSheet: RouteSheetTab) {
    routeSheet.total = total;
  }

  async setDetailsData(properties: any) {
    this.locationDTO = {
      identifier: properties.identifier,
      description: properties.description,
      lastVoltaje: properties.lastVoltage,
      batteryPercent: properties.batteryPercent,
      gpsStatus: properties.lastGPSStatus,
      canLock: properties.canLock,
      lastUpdate: properties.lastUpdate,
      activeType: properties.Tipo,
      id: properties.id,
      statusVehiculo: properties.statusVehiculo,
      idLocationCategory: properties.idLocationCategory,
      locationCategory: properties.locationCategory,
      icon: properties.icon,
      panelIcon: properties.icon,
      cordsY: properties.cordsY,
      cordsX: properties.cordsX,
      alias: properties.alias,
      categoryStatus: properties.categoryStatus,
      group: properties.group,
      subGroup: properties.subGroup,

      guid: "",
      color: "",
      data: [],
      counts: 0,
      isFullyAvailable: true,

      statusFlags: properties.statusFlags ? properties.statusFlags : [],
      flagTypes: properties.flagTypes ? properties.flagTypes : [],
    };

    console.log("SETDATA", properties);
    this.arrayMaster = Object.entries(properties.data);
    this.keys = [];
    this.values = [];
    this.arrayMaster.forEach((element) => {
      var obe: IGeoPosDataLocation;
      obe = JSON.parse(JSON.stringify(element[1]));
      this.keys.push(obe.key);
      this.values.push(obe.value);
    });

    // Obtener y asignar el nombre real de la categoría
    try {
      const categories = JSON.parse(localStorage.getItem('listaCategorias'));
      if (categories) {
        const category = categories.find((cat: any) => cat.id === this.locationDTO.idLocationCategory);
        this.locationCategoryShortName = category ? category.shortName : '';
      }
    } catch (error) {
      console.error("Error al obtener el nombre real de la categoría", error);
    }


    //Crea arrays de detalles del activo
    this.detallesActivo = this.keys.filter((item) => !item.includes("GPS"));
    // this.detallesActivo.sort();
    //Crea arrays de detalles del GPS
    this.detallesGPS = this.keys.filter((item) => item.includes("GPS"));
    // this.detallesGPS.sort();

    console.log("detalles", this.keys, this.detallesActivo, this.detallesGPS);

    // Hacer ambas llamadas en paralelo
    // const [keyNamesResult, imagesResult] = await Promise.all([
    //   firstValueFrom(this.locationService.getDataNames(this.keys)),
    //   this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier),
    // ]);

    const keyNamesResult = await firstValueFrom(
      this.locationService.getDataNames(this.keys.concat([this.locationDTO.locationCategory]))
    );

    if (keyNamesResult.isSuccess) {
      this.keyNames = keyNamesResult.result;
    }

    // Cargar imágenes de forma asíncrona sin bloquear
    this.loadImagesAsync();

    if (!!this.locationDTO.cordsX && !!this.locationDTO.cordsY && this.FlyToOnOpen) {
      this.mapHelperService.FlyToCamera(this.locationDTO.cordsY,
        this.locationDTO.cordsX,
        "15"
      );
    }
  }

  getUsableName(keyName: string): string {
    const keyNameObject = this.keyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.keyNames.find((item) => item.keyName === keyName);
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  CancelButton() {
    this.dialogRef.close();
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess(
      "Texto copiado al portapapeles",
      text
    );
  }

  private loadImagesAsync() {
    this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier).then((imagesResult) => {
        if (imagesResult != null && imagesResult.length > 0) {
          this.images = imagesResult;
          this.isLoadingImages = false;
        } else {
          this.images = [];
          this.isLoadingImages = false;
        }
      })
      .catch((error) => {
        this.images = [];
        this.isLoadingImages = false;
      });
  }

  selectTab(event: MatTabChangeEvent) {
    if (event.index == 0) {
      this.selectedTabIndex = 0;
    } else if (event.index == 1) {
      this.selectedTabIndex = 1;
    }
  }

  openDetailPanel(identifier: any) {
    this.isLoading = true;
    var locationsChildCategory = JSON.parse(localStorage.getItem('listaCategorias')).find((item) => item.name.includes(EnumLocationCategories.Location));
    if (locationsChildCategory == null || locationsChildCategory == undefined) {
      this.isLoading = false;
      return;
    }
    const filter = "";
    const includeGeoJSON = true;
    const orderValue = false;
    const isForceReload = false;
    if(this.location_getChildrenSubscription)
      this.location_getChildrenSubscription.unsubscribe();
    this.location_getChildrenSubscription = this.locationService.GetRouteSheet(this.parentIdentifier, locationsChildCategory.id, filter, includeGeoJSON, orderValue, isForceReload).subscribe(data => {
      if (data.isSuccess && data.result != null) {
        this.newDialogRef = this.dialog.open(LocationsLocationDetailPopupComponent, {
          maxWidth: "98vw",
          maxHeight: "92vh",
          autoFocus: false,
          restoreFocus: false,
          hasBackdrop: false,
          disableClose: true,
          data: {
            identifier: identifier,
            parentCoordX: this.locationDTO.cordsX,
            parentCoordY: this.locationDTO.cordsY,
            FlyToOnOpen: true,
            FlyToParentOnClose: true
          }
        });
    
        this.newDialogRef.afterClosed().subscribe(result => {
          
        });
        this.isLoading = false;
      }else{
        this.isLoading = false;
        this.notifyService.message("No se encontraron datos relacionados a la ubicación.");
      }
    });
    
  }
}
